export default __webpack_public_path__ + "static/media/fastingdrink@2x.bf16cdfa.jpg";